{
  "add_follow_up": "Добавить повторное письмо",
  "email_sequence_cancel": "Остановить",
  "email_sequence_cancel_confirmation": "Оставшиеся повторные письма не будут отправлены. Остановить эту цепочку?",
  "email_sequence_details_title": "Информация о цепочке писем",
  "email_sequence_email_position": "Это письмо {current} из {total}",
  "email_sequence_next_send": "Следующее письмо {date}",
  "email_sequence_next_send_interval": "Следующее отправится с {date_from} по {date_to}",
  "email_sequence_next_send_interval_same_day": "Следующее отправится {date} с {time_from} до {time_to}",
  "email_sequence_status_active": "Активна",
  "email_sequence_status_canceled": "Остановлена вручную",
  "email_sequence_status_completed": "Завершена",
  "email_sequence_status_failed": "Ошибка отправки",
  "email_sequence_status_replied": "Остановлена после ответа",
  "email_sequence_stopped": "{reason}: {date}",
  "email_status_pending": "Письмо ожидает отправки",
  "email_status_canceled": "Отправка письма отменена",
  "email_status_failed": "Не удалось отправить письмо",
  "email_integration_expired_error_with_link": "Срок подключения этого адреса электронной почты истёк. <reconnect>Переподключите</reconnect> его, чтобы продолжить отправку писем.",
  "email_integration_missing_title": "Почта не подключена",
  "email_integration_missing_description": "Подключите почтовый аккаунт, чтобы отправлять письма из %APP_NAME%",
  "first_message": "Первое сообщение",
  "flow_after_last_message": "{count}д после последнего сообщения",
  "flows_have_errors": "В некоторых повторных письмах есть ошибки, проверьте их",
  "follow_up_delay": "Отправить через (календарные дни)",
  "follow_up_delay_error": "Задержка должна быть от 1 до 30 календарных дней",
  "follow_up_limit_error": "Можно добавить не более 5 повторных писем",
  "follow_ups_description": "Письма отправляются в том же треде и с той же темой. Ответ кандидата останавливает цепочку",
  "follow_ups_immutable_description": "После запуска цепочки изменить её шаги нельзя",
  "action_assigned": "Назначено",
  "action_created": "Создано",
  "last_action_period": "Период последнего действия",
  "action_disqualified": "Отказ",
  "action_email_candidate_replied": "Кандидат ответил",
  "action_merged": "Объединен",
  "action_qualified": "Квалифицирован",
  "action_reserved": "Зарезервирован",
  "active_my_jobs": "Активные вакансии",
  "add_candidate": "Добавить кандидата",
  "add_notes": "Добавить заметки",
  "add_recruiter": "Добавить рекрутера",
  "add_stakeholder": "Добавить заинтересованное лицо или участника",
  "additional_contacts": "Дополнительные контакты",
  "additional_education": "Дополнительное образование",
  "ai_feature_title": "Функции ИИ",
  "all_jobs": "Все вакансии",
  "as_it_was_uploaded": "Как был загружен",
  "assign_to_job": "Назначить на вакансию",
  "ats": "Подбор персонала",
  "ats_description": "Отслеживание кандидатов от подачи заявки до решения о найме",
  "authors": "Кто добавил кандидата",
  "avg_days_to_close": "Среднее время закрытия (дни)",
  "avg_on_stage_time": "Среднее время на этапе",
  "avg_time": "Среднее время",
  "between_15_21_days": "15–21 дней",
  "between_22_30_days": "22–30 дней",
  "between_2_4_days": "2–4 дней",
  "between_5_7_days": "5–7 дней",
  "between_8_14_days": "8–14 дней",
  "broaden_the_filter": "Расширить фильтр",
  "candidate": "Кандидат",
  "candidate_for": "Кандидат для {job_info}",
  "candidates": "Кандидаты",
  "candidates_all": "Все кандидаты",
  "candidates_all_active": "Все активные",
  "career_sites": "Карьерные сайты",
  "career_sites_settings_description": "Управляйте карьерными сайтами с вашими активными вакансиями",
  "certificates": "Сертификаты",
  "change_stage": "Сменить этап",
  "choose_disqualification_reason": "Выберите причину отказа",
  "choose_stage": "Выберите причину",
  "chrome_extension": "Расш. для Chrome",
  "create_offer": "Создать оффер",
  "create_page": "Создать страницу",
  "creation_date": "Дата создания вакансии",
  "cv_added": "Добавлено резюме. Источник — {source}",
  "cv_hide_all_description": "Имя, фото, контактная информация, местоположение и другие личные данные будут скрыты",
  "cv_hide_other": "Скрыть личную информацию",
  "cv_hide_salary": "Скрыть зарплату",
  "cv_hide_salary_description": "Без упоминания зарплаты или компенсации",
  "cv_text": "Текст резюме",
  "cv_text_enter": "Введите текст резюме",
  "cv_updated_at": "Обновлено",
  "delete_candidate_confirm_description": "Удаление кандидата также приведет к удалению всех связанных кандидатов на вакансии",
  "did_not_find_anyone": "Мы никого не нашли по заданным фильтрам",
  "duplicate_job": "Дублировать вакансию",
  "duplicate_job_confirm": "Будет создана копия вакансии в виде черновика.",
  "disqualification": "Отказ",
  "disqualification_reason": "Причина отказа",
  "disqualification_reason_delete_confirm": "Вы хотите удалить причину?",
  "disqualification_reason_delete_confirm_description": "Если вы удалите эту причину, все кандидаты, которым было отказано по этой причине вернутся в активные",
  "disqualification_reasons": "Причины отказа",
  "disqualified": "Отказ",
  "disqualify": "Отказ",
  "disqualify_and_reserve": "Отказ и отправить в резерв",
  "edit_cv_text": "Изменить текст резюме",
  "edit_job": "Редактировать вакансию",
  "edit_offer": "Редактировать оффер",
  "education": "Образование",
  "experience": "Опыт работы",
  "filter_candidates": "Фильтр кандидатов",
  "filter_date_candidate_birth_from": "Дата рождения кандидата от",
  "filter_date_candidate_birth_to": "Дата рождения кандидата до",
  "filter_last_action_from": "Последнее действие от",
  "filter_last_action_to": "Последнее действие до",
  "gt_30_days": "> 30 дней",
  "hide_candidates_salary_info": "Скрыть зарплату кандидатов",
  "hide_candidates_salary_info_caption": "Скрытие может не работать, если у пользователя есть доступ через",
  "hide_candidates_salary_info_caption_settings": "настройки",
  "hire_candidate": "Нанять кандидата",
  "hired_candidates": "Нанятые кандидаты",
  "interview": "Интервью",
  "invite_candidate": "Пригласить кандидата",
  "job": "Вакансия",
  "job_archiving_reason": "Причина закрытия вакансии",
  "job_archiving_reasons": "Причины закрытия вакансий",
  "job_enter_description": "Заполните детали для вашей вакансии, включая всю доступную информацию",
  "job_offer_request": "Запрос на оффер",
  "job_offers": "Офферы",
  "job_priority": "Приоритет",
  "job_priority_high": "High",
  "job_priority_low": "Low",
  "job_priority_medium": "Medium",
  "job_priority_not_defined": "Не задан",
  "job_requirements_description": "Требования к должности",
  "job_requirements_title": "Требования к кандидату",
  "job_saved": "Вакансия успешно сохранена",
  "job_select_team": "Добавьте коллег для совместной работы над этой вакансией",
  "job_status_archived": "Архив",
  "job_status_draft": "Черновик",
  "job_status_on_hold": "На паузе",
  "job_status_published": "Активная",
  "job_summary": "Основное",
  "job_title": "Позиция",
  "jobs": "Вакансии",
  "jobs_closed_with_hire": "Вакансии закрыты с наймом",
  "jobs_filtered_by_selected_recruiters": "Список вакансий отфильтрован по выбранным рекрутерам",
  "join_us": "Присоединяйтесь к нам",
  "join_us_as": "Присоединяйтесь к нам как {jobTitle}",
  "lte_1_day": "≤ 1 день",
  "make_mandatory": "Сделать обязательным",
  "make_optional": "Сделать необязательным",
  "managed_by": "Руководитель",
  "max_salary": "Максимальная зарплата",
  "merge_with": "Объединить с",
  "merge_with_candidate": "Объединить с кандидатом",
  "merge_with_description": "Найдите кандидата, чей профиль дублирует этот. Дальше вы сравните профили и решите, объединять ли их.",
  "min_salary": "Минимальная зарплата",
  "move_to_next_stage": "Перевести на следующий этап",
  "move_to_stage_confirm": "Перевести кандидата на этап «{stage}»?",
  "multiple_emails": "<Множество email>",
  "my_active_jobs": "Активные вакансии",
  "my_candidates": "Мои кандидаты",
  "my_candidates_description": "Кандидаты, которых вы назначили на вакансии",
  "my_jobs": "Мои вакансии",
  "new_feature_ats_stage_flow_funnel": "Новые настройки конверсии в отчете по этапам вакансии",
  "no_jobs_assigned": "Вакансии не назначены",
  "no_rejected_duplicates": "Отклонённых дублей нет",
  "no_time_limit": "Без ограничения времени",
  "notification_settings_comments_caption": "Когда кто-то оставляет комментарий к кандидату на вашей вакансии",
  "notification_settings_mentions_caption": "Когда кто-то @упоминает вас",
  "offer": "Оффер",
  "offer_created": "Оффер создан",
  "offer_details": "Детали оффера",
  "offer_salary_annual_gross": "Годовая зарплата до удержаний",
  "offer_salary_annual_net": "Годовая зарплата к выплате",
  "offer_salary_monthly_gross": "Месячная зарплата до удержаний",
  "offer_salary_monthly_net": "Месячная зарплата к выплате",
  "offer_text": "Текст оффера",
  "offer_visibility": "Видимость оффера",
  "offer_waiting_for_approval": "Оффер ожидает согласования",
  "offer_waiting_for_your_approval": "Оффер ожидает вашего согласования",
  "organization_invites": "{organization} приглашает",
  "overdue": "Просрочено",
  "overdue_standard_time": "Норма времени",
  "permissions_delete_all_comments": "Удалять все комментарии",
  "permissions_delete_all_comments_description": "Позволяет удалять комментарии других",
  "permissions_delete_candidates": "Удалять кандидатов",
  "permissions_delete_candidates_description": "Позволяет удалять кандидатов из базы данных",
  "permissions_manage_candidates": "Управлять кандидатами",
  "permissions_manage_candidates_description": "Назначать кандидатов на вакансии, менять этапы и т. д.",
  "permissions_manage_career_sites": "Управление карьерными сайтами",
  "permissions_manage_career_sites_description": "Выбор этой опции открывает доступ к управлению карьерными сайтами",
  "permissions_manage_disqualification_reasons_description": "Управление причинами отказа кандидатов",
  "permissions_manage_job_archiving_reasons_description": "Управление причинами архивирования вакансий",
  "permissions_manage_jobs": "Управлять вакансиями",
  "permissions_manage_jobs_description": "Создавать и редактировать любую видимую вакансию",
  "permissions_manage_offers": "Управлять офферами",
  "permissions_manage_pipelines_description": "Управлять воронками найма, включая этапы",
  "permissions_manage_sources_description": "Управлять источниками найма для кандидатов на вакансии",
  "permissions_manage_tags_description": "Управление тегами для группировки кандидатов по навыкам, опыту и т. д.",
  "permissions_reporting_hiring_pipeline_description": "Просмотр отчетов по этапам",
  "permissions_reporting_recruiting_closing_time_description": "Просмотр отчетов о времени закрытия",
  "permissions_reporting_recruiting_disqualification_reasons_description": "Просмотр отчетов по причинам отказа",
  "permissions_reporting_recruiting_source_efficiency_description": "Просмотр отчетов по эффективности источников",
  "permissions_see_original_resume": "Просматривать исходное резюме",
  "permissions_see_original_resume_description": "Просмотр оригинального резюме, приложенного кандидатом",
  "permissions_show_all_candidates": "Показать всех кандидатов",
  "permissions_show_all_candidates_description": "Доступ ко всем кандидатам и их профилям",
  "permissions_show_all_jobs": "Показать все вакансии",
  "permissions_show_all_jobs_description": "Если отключено - будут видны только назначенные вакансии",
  "permissions_show_candidate_salary": "Показать зарплату кандидата",
  "permissions_show_candidate_salary_description": "Просмотр информации о зарплате кандидатов",
  "permissions_show_offers_salary": "Показать зарплату в оффере",
  "permissions_show_offers_salary_description": "Если выбрано, зарплата будет видна для всех видимых офферов",
  "permissions_show_salary": "Показать зарплату по вакансии",
  "permissions_show_salary_description": "Если выбрано, зарплата по вакансиям будет видна для всех видимых вакансий",
  "pipeline": "Воронка",
  "pipeline_default": "Воронка по умолчанию",
  "pipeline_stage_applied": "Все новые кандидаты начинают здесь. Это системный статус, его нельзя удалить",
  "pipeline_stage_hired": "Кандидат завершил все этапы процесса найма и принял предложение о работе. Начинается процесс адаптации. Это системный статус, его нельзя удалить",
  "pipeline_stage_offer": "Кандидат прошел все интервью и оценки и получил предложение о работе. Это системный статус, его нельзя удалить",
  "pipelines": "Воронки",
  "pipelines_description": "Управляйте этапами процесса подбора от поиска кандидата до предложения о работе",
  "pipelines_select_stages_description": "Порядок этапов управляется в разделе 'Этапы'. Чтобы добавить новый этап, сначала добавьте его в раздел 'Этапы', затем активируйте флажок",
  "pipelines_select_stages_title": "Выберите этапы, которые будут включены в воронку",
  "planned_start": "Запланированная дата старта",
  "potential_threat": "Подозрительный профиль",
  "potential_threat_default": "В профиле кандидата обнаружены признаки, требующие дополнительной проверки.",
  "potential_threat_mixed_characters": "В имени кандидата обнаружено смешение кириллических и латинских символов. Такой прием может использоваться для создания альтернативных или дублирующих профилей.",
  "potential_threat_ai_generated_cv": "Похоже, резюме оформлено с помощью ИИ. Само по себе это не нарушение и ничего не говорит о квалификации. Стоит учесть, что формулировки могут описывать опыт обобщённо — детали лучше уточнить на интервью.",
  "potential_threat_ai_generated_cv_tag": "AI text detected",
  "potential_threat_ai_generated_cv_beta": "Beta",
  "potential_threat_ai_generated_cv_disclaimer": "Проверка работает в тестовом режиме и может ошибаться.",
  "prepare_your_pdf": "Подготовьте ваш PDF",
  "prepare_your_word_file": "Подготовьте ваш word файл",
  "preview_offer": "Предварительный просмотр",
  "public_title": "Публичный заголовок вакансии",
  "public_title_information": "Если вы не введёте этот заголовок, на карьерном сайте отобразиться основной заголовок вакансии",
  "publish_jobs_to_career_pages": "Публикуйте ваши активные вакансии на автоматически сгенерированных карьерных страницах",
  "recruit": "Подбор",
  "recruit_module": "Модуль подбора",
  "recruit_module_description": "Предоставьте доступ к разделу найма платформы. Сотрудники без этого разрешения не увидят вакансии и кандидатов, назначенные на них",
  "recruiter": "Рекрутер",
  "recruiters": "Рекрутеры",
  "recruiters_involved": "Вовлеченные рекрутеры",
  "rejected_duplicates": "Отклонённые дубли",
  "rejected_duplicates_description": "Кандидаты, которых при проверке дублей отметили как разных людей.",
  "rejected_duplicates_return_hint": "Если это ошибка, верните кандидата в дубли: если профили похожи, объединение снова будет предложено.",
  "remove_from_job": "Удалить из вакансии",
  "report_closing_time": "Время закрытия",
  "report_closing_time_description": "Среднее время от заявки до предложения по позициям",
  "report_closing_time_title": "Отчет о времени закрытия",
  "report_disqualification_reason_table_description": "Распределение причин отклонения кандидатов в процессе найма",
  "report_disqualification_reason_table_title": "Анализ отказов кандидатов",
  "report_disqualification_reason_total_candidates": "Кандидатов с отказом",
  "report_disqualification_reason_totals_table_title": "Общий отчет по причинам отказа",
  "report_disqualification_reasons": "Причины отказа",
  "report_disqualification_reasons_description": "Причины отказа кандидатов на разных этапах найма",
  "report_disqualification_reasons_title": "Отчет по причинам отказа",
  "report_hiring_pipeline": "Воронка найма",
  "report_hiring_pipeline_description": "Отслеживание движения кандидатов по этапам найма",
  "report_hiring_pipeline_title": "Отчет по этапам",
  "report_source_efficiency": "Эффективность источников",
  "report_source_efficiency_table_description": "Количество кандидатов на каждом этапе за период времени",
  "report_source_efficiency_table_title": "Кандидаты на этапах по источникам найма",
  "report_source_efficiency_title": "Отчет об эффективности источников",
  "reserved": "Зарезервированные",
  "resume": "Резюме",
  "resume_files_cta": "файлы резюме",
  "return_to_duplicates": "Вернуть в дубли",
  "salary_visible": "Информация о зарплате видна",
  "search_placeholder_name_phone_links_email": "Имя, телефон, ссылки, электронная почта",
  "set_priority": "Задать приоритет",
  "setup_fields_for_career_site": "Настроить поля на карьерном сайте",
  "setup_job_fields_description": "Выберите, какие поля являются обязательными для кандидата",
  "setup_job_fields_title": "Настройка формы отклика кандидата",
  "setup_job_page": "Настроить страницу вакансии",
  "share_candidates_salary_info": "Показать зарплату кандидатов",
  "share_candidates_salary_info_caption": "Делает информацию о зарплате видимой для этого пользователя, независимо от глобальных настроек",
  "share_offer": "Поделиться оффером",
  "shareable_link_offer_description": "Сделать оффер общедоступным по ссылке",
  "similar_are_different": "Нет, это разные люди",
  "similar_candidate": "Похожий кандидат",
  "similar_candidate_found_description": "Пожалуйста, проверьте профили и решите, одинаковые ли это люди или нет",
  "similar_candidate_found_title": "Похожий кандидат есть в базе данных",
  "skills": "Навыки",
  "sorting_a_z": "Сортировка А-Я",
  "sorting_by_priority": "Сортировка по приоритету",
  "sorting_job_match": "Лучшая оценка",
  "sorting_most_recent": "Недавняя активность",
  "sorting_newest_candidates": "Новые кандидаты",
  "sources": "Источники",
  "stage": "Этап",
  "stage_add": "Добавить этап",
  "stages": "Этапы",
  "stages_description": "Убедитесь, что этапы воронки отражают реальные бизнес-процессы в компании",
  "stakeholders": "Заинтересованные стороны",
  "stakeholders_involved": "Вовлеченные заин. стороны",
  "tag": "Tag",
  "tag_add": "Добавить тег",
  "tags": "Теги",
  "time_limit_title": "Огр. по времени (дни)",
  "time_on_stage": "Время на этапе",
  "total_time_on_current_stage": "Общее время на текущем этапе",
  "try_broadening_filters": "Давайте попробуем расширить фильтры, и, возможно найдём кандидата",
  "unassign_from_job_description": "Вы уверены, что хотите снять с вакансии?",
  "unassign_from_job_title": "Снять с вакансии",
  "upload_cv_file": "Выберите файлы резюме",
  "upload_cv_file_drag_and_drop_description": "Принимаем до 10 (pdf, doc, docx, rtf, odt) файлов",
  "upload_files": "Загрузка файлов",
  "upload_success_count": "Загрузка завершена",
  "uploading_cvs": "Загрузка резюме",
  "uploading_cvs_count": "Загружаем {count} резюме",
  "use_ai_description": "Использовать ИИ для оценки кандидатов на основе их резюме и требований к должности",
  "use_ai_title": "Использовать ИИ для оценки кандидатов",
  "view_original": "Посмотреть оригинал",
  "view_in_modal": "Открыть в окне",
  "~": "~"
}
